import {
  IDiscount,
  IIndivPrice,
  IOfferPrice,
} from 'featureSliced/shared/store/reducers/SpecialsReducer/types'
import { ICategory } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

type FilterInput = {
  categories?: ICategory[]
  discounts?: IDiscount[]
  individualPrices?: IIndivPrice[]
  offerPrices?: IOfferPrice[]
}

type FilterResult = {
  discounts: IDiscount[]
  individualPrices: IIndivPrice[]
  offerPrices: IOfferPrice[]
  hasVisibleSpecials: boolean
}

// A special renders only when its product is in the current register's catalogue,
// and an active offer owns the product's tile: the charged price is min(offer,
// discounted), so a second discount/individual tile for the same product would
// duplicate it in the slider.
export const filterSpecialsForDisplay = ({
  categories,
  discounts,
  individualPrices,
  offerPrices,
}: FilterInput): FilterResult => {
  const catalogIds = new Set<number>()
  categories?.forEach((category) =>
    category.products?.forEach((product) => {
      if (product?.id !== undefined) catalogIds.add(Number(product.id))
    })
  )

  const inCatalog = <T extends { productId: number | string }>(items?: T[]) =>
    (items || []).filter((item) => catalogIds.has(Number(item?.productId)))

  const visibleOffers = inCatalog(offerPrices)
  const offerIds = new Set(
    visibleOffers.map((offer) => Number(offer.productId))
  )
  const notOffered = <T extends { productId: number | string }>(items: T[]) =>
    items.filter((item) => !offerIds.has(Number(item.productId)))

  const visibleDiscounts = notOffered(inCatalog(discounts))
  const visibleIndividualPrices = notOffered(inCatalog(individualPrices))

  return {
    discounts: visibleDiscounts,
    individualPrices: visibleIndividualPrices,
    offerPrices: visibleOffers,
    hasVisibleSpecials:
      visibleOffers.length > 0 ||
      visibleDiscounts.length > 0 ||
      visibleIndividualPrices.length > 0,
  }
}
